import classNames from "classnames";
import { get, isEmpty } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import { CURRENCY_SYMBOL } from "utils/constants";
import ActionButtons from "../Components/ActionButtons";
import Header from "../Components/Header";
import Layout from "../Components/Layout";
import DetailsModal from "./DetailsModal";
import UpsellsCard from "./UpsellsCard";

const formatCost = (cost) => Number(cost || 0).toFixed(2);

function View({
  onNext,
  onBack,
  upsells,
  selectedModules,
  handleModule,
  projectId,
  insurancePlanId,
  combinations = [],
  selectedCombinationIds = [],
  onToggleCombination,
}) {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.PROJECT);
  const [openDetails, setOpenDetails] = useState(null);

  const DETAIL = t("DETAIL", { returnObjects: true });
  const hasCombinationsToPick = combinations.length > 1;
  const submitDisabled =
    get(selectedModules, insurancePlanId)?.length === 0 ||
    (hasCombinationsToPick && selectedCombinationIds.length === 0);

  return (
    <Layout>
      <Header
        title="Renforcez votre formule santé grâce à nos <b>surcomplémentaires</b>"
        highlight="Renforcez votre formule santé"
        subtitle="Vos garanties optionnelles"
        onBack={onBack}
      />
      <div className="mobilityMutual-upsells-info">
        Vous pouvez sélectionner plusieurs surcomplémentaires : chaque
        combinaison sera proposée dans le devis.
      </div>
      <div className="upsells-wrapper">
        {upsells.map((module) => (
          <UpsellsCard
            key={module?.id}
            notSelected={
              !get(selectedModules, insurancePlanId)?.find(
                ({ insurancePlan }) =>
                  insurancePlan.id === get(module, "insurancePlan.id"),
              )
            }
            name={get(module, "insurancePlan.name") || ""}
            alias={get(module, "insurancePlan.alias") || ""}
            supportingInformation={
              get(module, "insurancePlan.supportingInformation") || []
            }
            cost={get(module, "cost")}
            currency={get(module, "currency")}
            onAdd={() => handleModule({ module })}
            onDetailsClick={() =>
              setOpenDetails(get(module, "insurancePlan.id"))
            }
          />
        ))}
      </div>
      {hasCombinationsToPick && (
        <div className="select-combination__list">
          <div className="select-combination__title">
            Sélectionnez les combinaisons à inclure dans votre devis
          </div>
          {combinations.map((combination) => {
            const symbol = CURRENCY_SYMBOL[combination.currency] || "";
            const isSelected = selectedCombinationIds.includes(combination.id);
            return (
              <div
                key={combination.id}
                className={classNames("select-combination__card", {
                  "select-combination__card--selected": isSelected,
                })}
                onClick={() => onToggleCombination(combination.id)}
              >
                <div className="select-combination__card--header">
                  <div className="select-combination__card--name">
                    {combination.label}
                  </div>
                  <div className="select-combination__card--price">
                    {formatCost(combination.totalCost)} {symbol}
                    <span className="select-combination__card--period">
                      {" "}
                      / mois
                    </span>
                  </div>
                </div>
                <div className="select-combination__card--detail">
                  <div>
                    <span>
                      {get(combination, "baseInsurancePlan.name", "—")}
                    </span>
                    <span>
                      {formatCost(combination.baseCost)} {symbol}
                    </span>
                  </div>
                  {combination.complementaryInsurancePlan && (
                    <div>
                      <span>
                        {get(
                          combination,
                          "complementaryInsurancePlan.name",
                          "—",
                        )}
                      </span>
                      <span>
                        {formatCost(combination.complementCost)} {symbol}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
      <ActionButtons
        buttonText={"Je souscris"}
        onNext={onNext}
        onBack={onBack}
        disabled={submitDisabled}
      />
      <div className="mobilityMutual__body--actions">
        <div className={"mobilityMutual-upsells-recap"}>
          <div
            onClick={() => onNext({ ignore: true })}
            className={classNames("mobilityMutual-upsells__item--link", {
              "mobilityMutual-upsells__item--link--hidden": !isEmpty(
                get(selectedModules, insurancePlanId),
              ),
            })}
          >
            Je ne souhaite pas de surcomplémentaire
          </div>
        </div>
      </div>
      {openDetails && (
        <DetailsModal
          centered
          open={openDetails}
          onClose={() => setOpenDetails(null)}
          filter={{
            where: {
              insurancePlan: { id: openDetails },
              project: { id: projectId },
            },
          }}
          translation={DETAIL.TEMPLATES.COMPARISON}
        />
      )}
    </Layout>
  );
}

export default View;
